import { render, staticRenderFns } from "./pinboardView.vue?vue&type=template&id=0d1e2c01&scoped=true"
import script from "./pinboardView.vue?vue&type=script&lang=js"
export * from "./pinboardView.vue?vue&type=script&lang=js"
import style0 from "./pinboardView.vue?vue&type=style&index=0&id=0d1e2c01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1e2c01",
  null
  
)

export default component.exports